export default "__VITE_ASSET__CbzdjUDv__"